export const searchMinLength = 3

export function getMatchScore(sourceStr, searchStr) {
  sourceStr = sourceStr.toLowerCase()
  searchStr = searchStr.toLowerCase()

  const words = searchStr.split(' ').filter(word => word.length >= searchMinLength)

  const wordToOccurrence = {}
  words.forEach(w => wordToOccurrence[w] = sourceStr.split(w).length - 1)

  const uniqueWordOccurrences = Object.values(wordToOccurrence).filter(o => o > 0).length
  const totalWordOccurrences = Object.values(wordToOccurrence).reduce((partialSum, a) => partialSum + a, 0)

  return uniqueWordOccurrences + (totalWordOccurrences / words.length)
}
